import { mapMutations, mapState } from 'vuex';

export default {
  computed: {
    ...mapState('jStoreAutomation', ['dataBlockIsDisable']),

    isDisableBlock() {
      if (this.dataParent && this.dataParent.length > 0) {
        return this.dataParent.some(i => !!i.is_disable) ||
          (this.dataEdit && this.dataEdit.is_disable);
      }
      return this.dataEdit && this.dataEdit.is_disable;
    },

    blockType() {
      if (typeof this.data_js !== 'undefined') return 'javascript';
      else if (typeof this.data_while !== 'undefined') return 'while';
      else if (typeof this.data_conditional !== 'undefined') return 'conditional';
      return this.objectType;
    },
  },

  methods: {
    ...mapMutations('jStoreAutomation', ['setDataBlockIsDisable']),

    updateIsDisableBlock() {
      if (!this.onProperties) {
        this.setDataBlockIsDisable({
          id: this.id,
          row: this.row,
          type: this.blockType,
          isDisable: this.isDisableBlock,
        });
      }

      const targetBlock = this.dataBlockIsDisable.find(i => i.id === this.id);
      if (targetBlock && this.blockType === 'javascript') {
        // this.data_js.is_disable = targetBlock.isDisable;
      } else if (targetBlock && this.blockType === 'while') {
        this.data_while.is_disable = targetBlock.isDisable;
      } else if (targetBlock && this.blockType === 'conditional') {
        this.data_conditional.is_disable = targetBlock.isDisable;
      } else if (targetBlock) {
        this.data_action.is_disable = targetBlock.isDisable;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/visual-programming/jMixAutomation.js